import React from "react";
import { FormField } from '@prosolve/common-components-ui'

export default ({
  formData
}) => {

  return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '15px',
        border: '1px solid #dedede',
        borderRadius: '5px',
        background: '#fdfdfd',
        padding: '10px',
      }}>
        <div style={{
          display: 'flex',
          columnGap: '15px'
        }}>
          <FormField
            style={{ flex: 1 }}
            fieldId='airlineFlightNumber'
            type='text'
            label='Flight Number'
            placeholder='e.g. 1021'
            formData={formData}
          />
          <FormField
            style={{ flex: 1 }}
            fieldId='takeOffCity'
            type='text'
            label='From'
            placeholder='e.g. Atlanta'
            formData={formData}
          />
          <FormField
            style={{ flex: 1 }}
            fieldId='landingCity'
            type='text'
            label='To'
            placeholder='e.g. Los Angeles'
            formData={formData}
          />
        </div>
        <div style={{
          display: 'flex',
          columnGap: '15px'
        }}>
          <FormField
            style={{ flex: 1 }}
            fieldId='takeOff'
            type='date'
            label='Departure Date'
            placeholder='Select Date'
            formData={formData}
          />
          <FormField
            style={{ flex: 1 }}
            fieldId='takeOffTime'
            type='time'
            label='Departure Time'
            formData={formData}
          />
          <FormField
            style={{ flex: 1 }}
            fieldId='landingTime'
            type='time'
            label='Arrival Time'
            formData={formData}
          />
        </div>
      </div>
  )
}